import React from 'react';
import { Link } from 'react-router-dom';
import downloadIcon from '../../resources/download-icon.svg';
import resumePdf from '../../resources/footer/resume.pdf';
import './Navigation.css';

interface NavigationProps {
  links?: Array<{
    label: string;
    href: string;
    download?: string;
    isExternal?: boolean;
    isButton?: boolean;
  }>;
}

const Navigation: React.FC<NavigationProps> = ({
  links = [
    { label: 'Projects', href: '/' },
    { label: 'About', href: '/about' },
    {
      label: 'Resume',
      href: resumePdf,
      download: 'Constanza_De_Rienzo_Resume.pdf',
      isExternal: true,
      isButton: true
    }
  ]
}) => {
  return (
    <nav className="navigation">
      <div className="nav-links">
        {links.map((link) => {
          if (link.isExternal) {
            return (
              <a
                key={link.label}
                href={link.href}
                download={link.download}
                target="_blank"
                rel="noopener noreferrer"
                className={`nav-link ${link.isButton ? 'nav-button' : ''}`}>
                {link.isButton && (
                  <img
                    src={downloadIcon}
                    width="14"
                    height="14"
                    alt=""
                    aria-hidden="true"
                    className="nav-icon"
                  />
                )}
                {link.label}
              </a>
            );
          }

          return (
            <Link key={link.label} to={link.href} className="nav-link">
              {link.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default Navigation;
